module.exports = __webpack_public_path__ + "static/media/help-modal-top.22ccb6cf.png";